import { Link } from "react-router-dom";
import logo from "../assets/logo-full.png";

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="site-logo" className={`inline-flex items-center group ${className}`}>
    <img
      src={logo}
      alt="The Tech Savvy Company logo"
      className="h-14 w-auto object-contain group-hover:scale-105 transition-transform"
    />
  </Link>
);
